import { SortParams } from '@epicuro-next/data/baskets';

export function getSortParams(
  fallback: SortParams,
  current?: Partial<SortParams>,
): SortParams {
  return {
    type: current?.type || fallback.type,
    direction: (current?.type && current.direction) || fallback.direction,
  };
}
